import { render, staticRenderFns } from "./mktError.vue?vue&type=template&id=6b18cb6c&"
import script from "./mktError.vue?vue&type=script&lang=js&"
export * from "./mktError.vue?vue&type=script&lang=js&"
import style0 from "./mktError.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports